module.exports = __webpack_public_path__ + "img/Metz.1b411f0a.png";